import React, { useState } from 'react';

const defaultButtonStyle = {
    position: 'absolute',
    top: '50%',
    right: 10,
    transform: 'translateY(-50%)',
    border: 'none',
    background: 'transparent',
    color: 'rgba(255,255,255,0.6)',
    cursor: 'pointer',
    fontSize: 16,
    lineHeight: 1,
    padding: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

export default function PasswordField({
    style,
    containerStyle,
    buttonStyle,
    inputRef,
    ...props
}) {
    const [visible, setVisible] = useState(false);

    return (
        <div style={{ position: 'relative', width: '100%', ...containerStyle }}>
            <input
                {...props}
                ref={inputRef}
                type={visible ? 'text' : 'password'}
                style={{
                    width: '100%',
                    paddingRight: 42,
                    ...style,
                }}
            />
            <button
                type="button"
                aria-label={visible ? 'Hide password' : 'Show password'}
                title={visible ? 'Hide password' : 'Show password'}
                onClick={() => setVisible(v => !v)}
                style={{ ...defaultButtonStyle, ...buttonStyle }}
            >
                {visible ? '🙈' : '👁'}
            </button>
        </div>
    );
}
